<template>
  <div id="app" ref="app">
    <b-alert :show="loading" variant="info">Loading...</b-alert>
    <div id="jsmind_container" ref="jsmind_container">
      <radial-menu
        style="position: fixed; z-index: 3; margin-top: 1%; margin-left:85%; background-color: white"
        :itemSize="60"
        :radius="120"
        :angle-restriction="180"
        :rotate="180">
        <radial-menu-item
          v-for="(item, index) in items"
          :key="index"
          style="background-color: white"
          @click="() => handleClick(item)">
          <span>{{item}}</span>
        </radial-menu-item>
      </radial-menu>
    </div>
    <!--    <router-view/>-->
  </div>
</template>

<script>
import 'jsmind/style/jsmind.css'
// import './assets/jsmind/style/jsmind.css'
import jsMind from 'jsmind'
import api from '@/api'
import {RadialMenu, RadialMenuItem} from 'vue-radial-menu'

global.jsMind = require('jsmind')
require('jsmind/js/jsmind.draggable')

export default {
  name: 'App',
  components: {
    RadialMenu,
    RadialMenuItem
  },
  data: function () {
    return {
      jm: {},
      markdown: '',
      mind: {},
      lastLevel: 0,
      items: ['expand_all', 'collapse_all', 'todo_filter'],
      lastClicked: 'click on something!',
      model: {},
      loginModel: {},
      loading: false
    }
  },
  async created () {
    this.markdown = await api.getMarkdown()
    // this.mind = await api.getData()
    // this.load_jsmind()
    this.set_container_size()
    this.load_markdown()
    this.lastLevel = 0
    this.show_jsmind()
  },
  mounted: function () {
  },
  methods: {
    load_markdown () {
      this.mind = {
        'meta': {'name': 'jsMind remote', 'author': 'ssst0n3@gmail.com', 'version': '0.2'},
        'format': 'node_tree',
        'data': {}
      }
      // console.log(this.markdown)
      this.markdown.split('\n').forEach(line => {
        let node = this.parse_line(line)
        if (node !== null) {
          if (node.level === 1) {
            this.mind.data = node
            // console.log('init:', this.mind.data)
          } else if (node.level > this.lastLevel) {
            let l = 1
            let n = this.mind.data
            while (l < this.lastLevel) {
              // console.log(l)
              // console.log('n:', n)
              n = n.children[n.children.length - 1]
              l += 1
            }
            n['children'].push(node)
            // console.log(this.mind.data)
          } else if (node.level <= this.lastLevel) {
            let l = 0
            let n = this.mind.data
            while (l < node.level - 2) {
              n = n.children[n.children.length - 1]
              l += 1
            }
            n['children'].push(node)
            // console.log(this.mind.data)
          }
          this.lastLevel = node.level
        }
      })
    },
    parse_line (line) {
      let regex = new RegExp('\\s*(#+)\\s(.*)<!-- (.*) -->')
      // line = line.trim()
      if (line.startsWith('#')) {
        // let level = line.split(' ')[0].length
        let level = regex.exec(line)[1].length
        let topic = regex.exec(line)[2]
        let options = regex.exec(line)[3]
        let node = JSON.parse(options)
        node['id'] = level === 1 ? 'root' : jsMind.util.uuid.newid()
        node['topic'] = topic
        node['level'] = level
        node['children'] = []
        return node
      }
      return null
    },
    show_jsmind () {
      var options = {
        container: 'jsmind_container',
        editable: true,
        theme: 'asphalt'
      }
      console.log(this.mind)
      this.jm = jsMind.show(options, this.mind)

      document.querySelectorAll('jmnode').forEach(e => {
        if (e.childElementCount > 0) {
          let linkAlt = document.createElement('i')
          if (e.innerText.startsWith('[external]')) {
            linkAlt.setAttribute('class', 'fas fa-external-link-alt')
            linkAlt.setAttribute('style', 'margin-left:4px; color: coral')
          } else {
            linkAlt.setAttribute('class', 'fas fa-link')
            linkAlt.setAttribute('style', 'margin-left:4px')
          }
          e.firstElementChild.append(linkAlt)
        } else if (e.innerText.startsWith('[todo]')) {
          let linkAlt = document.createElement('i')
          linkAlt.setAttribute('class', 'fas fa-lightbulb')
          linkAlt.setAttribute('style', 'margin-left:4px; color: greenyellow')
          e.append(linkAlt)
        }
      })
    },
    load_jsmind () {
      // var options = {
      //   container: 'jsmind_container',
      //   editable: true,
      //   theme: 'asphalt'
      // }
      // jsMind.show(options, this.mind)
      // jm.set_readonly(true);
      // var mind_data = jm.get_data();
      // alert(mind_data);
      // jm.add_node('sub2', 'sub23', 'new node', { 'background-color': 'red' })
      // jm.set_node_color('sub21', 'green', '#ccc')
      let markdown = this.render_markdown(this.mind.data, '', 1)
      console.log(markdown)
    },
    render_markdown (node, markdown, depth) {
      let attr = {
        'expanded': node.expanded ? node.expanded : false,
        'direction': node.direction ? node.direction : 'right'
      }
      markdown += '#'.repeat(depth) + ' ' + node.topic + '<!-- ' + JSON.stringify(attr) + ' -->\n'
      node.hasOwnProperty('children') && node.children.forEach(child => {
        markdown = this.render_markdown(child, markdown, depth + 1)
      })
      return markdown
    },
    set_container_size () {
      // let container = this.$refs.app
      // container.style.height = (window.innerHeight).toString() + 'px'
      // container.style.width = (window.innerWidth).toString() + 'px'
      // var ch = $w.innerHeight - _h_header;
      // var cw = $w.innerWidth;
      let container = document.getElementById('jsmind_container')
      container.style.height = window.innerHeight - 16 + 'px'
      container.style.width = window.innerWidth - 8 + 'px'
    },
    expand_parent (node) {
      console.log(node.topic, node.hasOwnProperty('parent'))
      if (node.hasOwnProperty('parent') && node.parent !== undefined) {
        this.jm.expand_node(node.parent)
        this.expand_parent(node.parent)
      }
    },
    todo_filter (node) {
      if (node.topic.startsWith('[todo]')) {
        this.expand_parent(node)
      }
      node.children.forEach(child => {
        this.todo_filter(child)
      })
    },
    async handleClick (item) {
      console.log(item)
      if (item === 'expand_all') {
        this.jm.expand_all()
      } else if (item === 'collapse_all') {
        this.jm.collapse_all()
      } else if (item === 'todo_filter') {
        this.jm.collapse_all()
        this.todo_filter(this.jm.mind.root)
      }
    }
  }
}
</script>

<style>
  /*#app {*/
  /*  font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*  -webkit-font-smoothing: antialiased;*/
  /*  -moz-osx-font-smoothing: grayscale;*/
  /*  text-align: center;*/
  /*  color: #2c3e50;*/
  /*  margin-top: 60px;*/
  /*}*/
  html {
    /*width: 100%;*/
  }

  body {
    /*width: 100%;*/
    /*height: 100%;*/
  }

  #app {
    /*min-width: 1200px;*/
    /*min-height: 1200px;*/
    /*width: 100%;*/
    /*max-height: 100%;*/
    /*height: 100%;*/
    margin: 0 auto;
    font-family: "Helvetica Neue", "PingFang SC", Arial, sans-serif;
  }

  #jsmind_container {
    /*width:800px;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*border:solid 1px #ccc;*/
    /*background:#f4f4f4;*/
    background: #f4f4f4;
  }

  .container {
    max-width: 100%;
  }

  a {
    text-decoration: none;
  }

  a, a:hover {
    color: turquoise !important;
  }

  jmnode {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
  }

  jmnodes {
    min-width: 420px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue